import { render, staticRenderFns } from "./Auth0Config.vue?vue&type=template&id=1bf86d44&scoped=true&"
import script from "./Auth0Config.vue?vue&type=script&lang=ts&"
export * from "./Auth0Config.vue?vue&type=script&lang=ts&"
import style0 from "./Auth0Config.vue?vue&type=style&index=0&id=1bf86d44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf86d44",
  null
  
)

export default component.exports